document.addEventListener('DOMContentLoaded', () => {
  const processContent = (rootElement) => {
    // Get all text nodes inside the element
    const textNodes = [];
    const walker = document.createTreeWalker(rootElement, NodeFilter.SHOW_TEXT, null, false);

    let node;
    while (node = walker.nextNode()) {
      // Skip script and style tags
      if (!isInScriptOrStyle(node)) {
        textNodes.push(node);
      }
    }

    textNodes.forEach((textNode) => {
      if (!textNode.nodeValue || textNode.nodeValue.trim() === '') return

      const originalText = textNode.nodeValue;

      const newText = originalText.replace(
        /(\d+?)\s([A-Za-z]+)/g,
        (_match, number, unit) => number + '\u00A0' + unit
      );

      if (newText !== originalText) textNode.nodeValue = newText;
    });
  }

  const isInScriptOrStyle = (node) => {
    let parent = node.parentNode;
    while (parent) {
      if (parent.tagName === 'SCRIPT' || parent.tagName === 'STYLE') {
        return true;
      }
      parent = parent.parentNode;
    }
    return false;
  }

  // Initial processing of existing content
  processContent(document.body);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Only process element nodes
          processContent(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
